(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    }
    document.getElementById('adluge-session').value = getCookie("_adl_id.AL_2285");
    const taxInput = document.getElementById("tax-exemption-card");

  if (taxInput) {
    taxInput.addEventListener("change", function() {
      const value = taxInput.value;

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            "Tax Exemption Card Number": value
          }
        })
      })
      .then(res => res.json())
      .then(cart => {
        console.log("Saved cart attributes:", cart.attributes);
      })
      .catch(err => console.error("Cart attribute save failed:", err));
    });
  }
  });
  } catch(e) { console.error(e); }
})();

})();
